import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Kategorie',
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa kategorii',
      fieldRequired: true,
      maxLength: 500
    }
  }
};
